import { createContext } from 'react';

import { GRSkinId } from '../types/global';

export type GRContextProps = {
  skinId?: GRSkinId;
  logoImgPath?: string;
};

export const GRContext = createContext<GRContextProps>({});
